import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONVERSATION_MODES } from '../../../constants/modes';
import './ChatBadge.scss';

const VARIATIONS = {
  [CONVERSATION_MODES.PRACTICE]: {
    emoji: '🎯',
    translationKey: 'Practice Mode',
  },
  [CONVERSATION_MODES.STUDY]: {
    emoji: '✨',
    translationKey: 'Study Mode',
  },
  [CONVERSATION_MODES.REVISION]: {
    emoji: '📝',
    translationKey: 'Revision Mode',
  },
};

function ChatBadge({ className, variation }) {
  const { t } = useTranslation(['chatbot']);
  const selectedVariation = VARIATIONS[variation] || VARIATIONS[CONVERSATION_MODES.STUDY]; // Default to study if invalid

  const componentClass = classNames('chat-badge', `chat-badge--${variation}`, className);

  return (
    <div className={componentClass}>
      <span className="chat-badge__emoji" role="img" aria-hidden="true">
        {selectedVariation.emoji}
      </span>
      <span className="chat-badge__text">{t(selectedVariation.translationKey)}</span>
    </div>
  );
}

ChatBadge.propTypes = {
  className: PropTypes.string,
  variation: PropTypes.oneOf([CONVERSATION_MODES.PRACTICE, CONVERSATION_MODES.STUDY, CONVERSATION_MODES.REVISION]).isRequired,
};

ChatBadge.defaultProps = {
  className: '',
};

export default ChatBadge;
